import { ActionType, createReducer } from 'typesafe-actions';
import { AuthState, AuthTypes } from './types';
import authActions, { logout } from './actions';

export const INITIAL_STATE: AuthState = {
  userInfo: null,
  error: 0,
  isLoading: false,
};

export type RootAuthAction =
  | ActionType<typeof authActions>
  | ReturnType<typeof logout>;

const authReducer = createReducer<AuthState, RootAuthAction>(INITIAL_STATE, {
  [AuthTypes.AuthRequest]: (state: AuthState) => ({
    ...state,
    isLoading: true,
    error: 0,
  }),
  [AuthTypes.AuthSuccess]: (state, action) => {
    return {
      userInfo: action.payload,
      isLoading: false,
      error: 0,
    };
  },
  [AuthTypes.AuthFailure]: (state, action) => {
    return {
      isLoading: false,
      error: action.payload,
      userInfo: null,
    };
  },
  [AuthTypes.Logout]: () => {
    return {
      isLoading: false,
      error: 0,
      userInfo: null,
    };
  },
});

export default authReducer;
